import {useCallback} from 'react';

import {HomeEnum} from 'presentation/constants';
import {useNavigate} from 'react-router-dom';
import {useCreateTokenQuery} from '../../queries/useCreateTokenQuery';

export function useBeneficiaryToken() {
	const navigate = useNavigate();

	const {data: tokenData, isFetching, error, refetch} = useCreateTokenQuery();

	const handleBack = useCallback(() => {
		navigate(HomeEnum.HOME_PAGE);
	}, []);

	const isEmpty = !isFetching && !tokenData?.token;

	const expirationDateTime = tokenData?.expirationDateTime;
	const remainingTimeInSeconds = expirationDateTime
		? Math.round((new Date(expirationDateTime).getTime() - new Date().getTime()) / 1000)
		: 0;

	return {
		remainingTimeInSeconds,
		isLoading: isFetching,
		isError: error,
		isEmpty,
		handleFetchToken: refetch,
		handleBack,
		tokenNumber: tokenData?.token ?? '',
	};
}
